<template>
  <div class="memberPie" ref="echarts"></div>
</template>

<script>
import { EchatsMixin } from "@/utils/echarts";

export default {
  mixins: [EchatsMixin],
  props: ["takePaper"],
  name: "paperWeekEcharts",
  data() {
    return {};
  },
  watch: {
    takePaper: {
      handler(n) {
        if (n) {
          this.weekPaper(n);
        }
      },
      deep: true
    }
  },
  methods: {
    getWeek(dateString) {
      let dateArray = dateString.split("-");
      let date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },

    weekPaper(moto) {
      /*
      定义日历图x轴data属性
      hour:string
      */
      const hour = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ];
      /*
      定义日历图y轴data属性
      days:string
      */
      const days = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

      //日期——日期根据dayjs插件转换为星期几方便挂载至日历图y轴
      let dataOf = [];
      //echarts图表series配置内的data
      let data = [];

      if (moto !== undefined) {
        for (let i = 0; i < moto.length; i++) {
          //获取拥有的星期数
          dataOf.push(this.getWeek(moto[i].date));
          //获取当前星期下的使用次数和时间
          moto[i].countList.forEach(item => {
            //根据当前星期排序拼接完成所需数据结构
            data.push([
              dataOf.indexOf(this.getWeek(moto[i].date)),
              parseInt(item.hour),
              parseInt(item.num)
            ]);
          });
        }
      }

      //日历图数据形式[x,y,z]
      data = data.map(function(item) {
        return [item[1], item[0], item[2] || "-"];
      });
      //调用EchartsMixin组件内的自适应方法获取dom
      let myChart = this.resizeEcharts();
      // EleResize.on(listener);
      // myChart.setOption({
      let option = {
        tooltip: {
          position: "top", //鼠标悬浮提示框位置
          formatter:function(p){
            console.log(p,'打印数据');
            let message='次数：'
            let time = '时间：'
            let fh = ":00"
            let data = p.data[1]
            let x = ''
            switch (data)
            {
              case 0:x="周一";
              break;
              case 1:x="周二";
              break;
              case 2:x="周三";
              break;
              case 3:x="周四";
              break;
              case 4:x="周五";
              break;
              case 5:x="周六";
              break;
              case 6:x="周日";
              break;
            }

            let col = {
              fontSize: 16,
              textShadowBlur: 5,
              textShadowColor: '#000',
              textShadowOffsetX: 3,
              textShadowOffsetY: 3,
              color: '#fff'
            }
            let msgDateNum = `
            <div style="backgroundColor:red">
            <span style="${col}">
              ${x}
            </span>
            <br>
            <hr color=${p.color}>
            ${p.marker}${time}${p.data[0]}${fh}
            <br>
            ${p.marker}${message}${p.data[2]}${'次'}
            </div>
            `
            return msgDateNum
          },
        },
        grid: {
          top: 45,
          right: 35,
          left: 35,
          bottom: 10,
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: hour,
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: "category",
          data: days,
          splitArea: {
            show: true
          }
        },
        visualMap: {
          // min: 1,
          // max: 20,
          type: "piecewise",
          calculable: true,
          orient: "horizontal",
          left: "center",
          top: 5,
          pieces: [
            {
              gt: 0,
              lte: 5,
              color: '#ffcc33'
            },
            {
              gt: 5,
              lte: 15,
              color: '#ff9933'
            },
            {
              gt: 15,
              lte: 25,
              color: ' #ff6633'
            },
            {
              gt: 25,
              color: '#ff3333'
            }
          ],
        },
        series: [
          {
            name: "使用频次",
            type: "heatmap",
            data: data,
            label: {
              show: true
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",

              }
            }
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option, true);
    }
  },

  created() {}
};
</script>

<style scoped>
.memberPie {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/html/paperWeekEcharts.vue